import {
	mockSaveColumnView,
	MY_LQA_COLUMN_VIEW_QUERY_KEY,
} from '@lqa-frontend/api-services';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface UpdateMyLqaColumnViewVariables {
	viewKey: string;
	columns: string[];
}

export function useMyLqaColumnViewUpdateMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: UpdateMyLqaColumnViewVariables) =>
			mockSaveColumnView(variables.viewKey, variables.columns),
		onSuccess: async (_result, variables) => {
			await queryClient.invalidateQueries({
				queryKey: [MY_LQA_COLUMN_VIEW_QUERY_KEY, variables.viewKey],
			});
		},
	});
}
